import { LOCALES } from "common/constants";
import Loader from "components/Loader";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const InvoiceInfoModal = ({ show, setShow }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    if (show?.data) {
      window.dispatchEvent(new Event('resize'));
    }
  }, [show?.data]);

  return (
    <>
      <Modal
        show={true}
        onHide={() => setShow({ ShowInvoiceInfo: false })}
        onEntered={() => {
          window.dispatchEvent(new Event('resize'));
        }}
      >
        <Modal.Header>
          <Modal.Title>{t("Invoice")}</Modal.Title>
          <AiOutlineClose
            className="ml-auto cursor-pointer"
            size={24}
            onClick={() => setShow({ ShowInvoiceInfo: false })}
          />
        </Modal.Header>
        <Modal.Body>
          {show?.data ? (
            <div className="page-content EconomyInvoices">
              <div className="invoice-details-container">
                <div className="invoice-details-part-container flex-column w-100">
                  <span className="invoice-details-title"></span>
                  <div className="invoice-details-wrapper new_clor pt-20">
                    <div className="invoice-details-row-container">
                      <div className="invoice-details-part-container w-100 f-culm">
                        <div className="invoice-details-row-column padding">
                          <div className="invoice-details-title-head">
                            <span>{t("Invoice Information")}</span>
                          </div>

                          <div className="invoice-details-row">
                            {" "}
                            <p className="mb-2">
                              <strong>{t("Invoice Amount")} : </strong>
                              {show.data?.amount}
                            </p>
                          </div>
                          <div className="invoice-details-row">
                            {" "}
                            <p className="mb-2">
                              <strong>{t("Amount Inc. VAT")} : </strong>
                              {show.data?.amountIncVat}
                            </p>
                          </div>
                          <div className="invoice-details-row">
                            {" "}
                            <p className="mb-2">
                              <strong>{t("Currency")} : </strong>
                              {show.data?.currency}
                            </p>
                          </div>
                        </div>
                        <div className="invoice-details-row-column padding">
                          <div className="invoice-details-title-head">
                            <span>{t("CUSTOMER INFORMATION")}</span>
                          </div>
                          <div className="invoice-details-row">
                            <p className="mb-2">{show.data.customer?.name}</p>
                          </div>
                          <div className="invoice-details-row">
                            <p className="mb-2">
                              #-{show.data?.customer?.zipCode}
                            </p>
                          </div>
                          <div className="invoice-details-row">
                            <p className="mb-2">
                              {show.data?.customer?.co} ,{" "}
                              {show.data?.customer?.city}
                            </p>
                          </div>
                          <div className="invoice-details-row ">
                            <p className="mb-2 d-flex">
                              {show.data?.customer?.country}
                            </p>
                          </div>
                          <div className="invoice-details-row">
                            {" "}
                            <p className="mb-2">
                              <strong>{t("Reference")} : </strong>
                              {show.data?.customer?.reference}
                            </p>
                          </div>
                          <div className="invoice-details-row">
                            <p className="mb-2">
                              <strong>{t("Email Address")} : </strong>
                              <span title={show.data?.customer?.email}>
                                {show.data?.customer?.email
                                  ?.substring(0, 25)
                                  .concat("...")}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="invoice-details-column-divider"></div>
                        <div className="invoice-details-row-column padding">
                          <div className="invoice-details-title-head">
                            <span>{t("SELECTED FREELANCERS")}</span>
                          </div>
                          <div className="invoice-details-row">
                            <p className="mb-2">
                              <strong>
                                {show.data.invoiceApprovalFreelancers?.length ===
                                  0 ||
                                  show.data.invoiceApprovalFreelancers === null
                                  ? t("No freelancers selected")
                                  : t("email") + " :"}
                              </strong>
                            </p>
                          </div>
                          {show.data.invoiceApprovalFreelancers?.length > 0 &&
                            show.data.invoiceApprovalFreelancers.map(
                              (item, index) => (
                                <div key={index} className="new_clor">
                                  {index + 1}
                                  {" ) "}
                                  <span title={item.freelancerDetails?.email}>
                                    {item.freelancerDetails?.email
                                      .substring(0, 16)
                                      .concat("...")}
                                  </span>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                      <div className="invoice-view-activity-status-container"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="outline_btn_new preliminary-invoice"
            variant="secondary"
            onClick={() => {
              setShow({ ShowInvoiceInfo: false });
            }}
          >
            {t("Cancel")}
          </button>
          <Button
            className="new_theme_btn preliminary-invoice"
            onClick={() => {
              if (language === LOCALES.EN_US) {
                navigate(`/dashboard/invoice-tool?lang=${LOCALES.EN_US}`, {
                  state: show?.data?.id,
                });
              } else {
                navigate(`/instrumentbrada/faktura-verktyg?lang=${LOCALES.SV_SE}`, {
                  state: show?.data?.id,
                });
              }
            }}
          >
            {t("Go to created preliminary")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
